// removed by extract-text-webpack-plugin
module.exports = {"root":"EnterpriseFooter__root___FFrJt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseFooter/EnterpriseFooter.scss
// module id = 1011
// module chunks = 0